<div class="card__top-center">
  <h3>{{ titleKey() | translate }}</h3>
  <div class="card__top-actions">
    @if (!isTerminated()) {
      @if (isDirty()) {
        <div style="display: flex; flex-direction: row; align-items: center; gap: 6px">
          <span>{{ "Services.Status.Locked" | translate }}</span>
          <svg-icon
            style="align-self: center"
            src="assets/images/icons/lock.svg"
            [matTooltip]="'Selfservice.Tooltip.Locked' | translate"
          ></svg-icon>
        </div>
      }
      @if (showNotificationButton()) {
        <notification-button [subscription]="subscription()" />
      }
      @if (showReportIncidentButton()) {
        <report-incident [subscription]="subscription()" />
      }
    }
  </div>
</div>
